module.exports = __webpack_public_path__ + "static/img/thumb-04.db601a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/thumb/thumb-04.png
// module id = nE7f
// module chunks = 150